import alt from '../alt'
import AuthActions from '../actions/AuthActions'
import jwtDecode from 'jwt-decode'
import axios from '../axios'

class AuthStore {
  constructor () {
    this.hvbToken = window.localStorage.getItem('hvbToken')
    this.user = this.hvbToken ? jwtDecode(this.hvbToken).user : null
    this.admin = this.hvbToken ? jwtDecode(this.hvbToken).admin : null
    this.fetching = false
    this.errorMessage = null

    this.bindListeners({
      loginSuccess: AuthActions.LOGIN_SUCCESS,
      loginFailed: AuthActions.LOGIN_FAILED,
      logout: AuthActions.LOGOUT,
      loginAdmin: AuthActions.LOGIN_ADMIN,
      loginAdminSuccess: AuthActions.LOGIN_ADMIN_SUCCESS,
      logoutAdmin: AuthActions.LOGOUT_ADMIN,
      updateToken: AuthActions.UPDATE_TOKEN,
      storeToken: AuthActions.STORE_TOKEN,
      cleanError: AuthActions.CLEAN_ERROR
    })
  }

  cleanError () {
    this.fetching = false
    this.errorMessage = null
  }

  loginAdmin () {
    this.fetching = true
  }

  loginAdminSuccess (data) {
    this.fetching = false
    window.localStorage.setItem('hvbToken', data.authToken)
    axios.defaults.headers['Authorization'] =
      'BEARER ' + window.localStorage.getItem('hvbToken')
    this.hvbToken = window.localStorage.getItem('hvbToken')
    this.admin = data.admin
    this.errorMessage = null
  }

  loginSuccess (data) {
    this.fetching = false
    window.localStorage.setItem('hvbToken', data.authToken)
    this.hvbToken = window.localStorage.getItem('hvbToken')
    axios.defaults.headers['Authorization'] =
      'BEARER ' + window.localStorage.getItem('hvbToken')
    this.user = data.user
    this.errorMessage = null
    window.location = '/'
  }

  logoutAdmin () {
    this.fetching = false
    this.admin = null
    window.localStorage.removeItem('hvbToken')
    axios.defaults.headers['Authorization'] = 'BEARER ' + null
    this.hvbToken = null
    this.errorMessage = null
  }

  logout () {
    this.fetching = false
    this.user = null
    window.localStorage.removeItem('hvbToken')
    axios.defaults.headers['Authorization'] = 'BEARER ' + null
    this.hvbToken = null
    this.errorMessage = null
  }

  loginFailed (errorMessage) {
    this.errorMessage = errorMessage
    this.fetching = false
  }

  updateToken (token) {
    this.hvbToken = token
    window.localStorage.setItem('hvbToken', token)
    this.user = jwtDecode(token).user
  }

  storeToken (data) {
    this.fetching = false
    window.localStorage.setItem('hvbToken', data.authToken)
    this.hvbToken = data.authToken
    axios.defaults.headers['Authorization'] = 'BEARER ' + data.authToken
    this.errorMessage = null
  }
}

module.exports = alt.createStore(AuthStore, 'AuthStore')



// WEBPACK FOOTER //
// ./src/stores/AuthStore.js